import type { SVGProps } from 'react';

const SvgTextEditor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M11.52 17.28c-.21 0-.4-.07-.57-.19-.16-.12-.29-.3-.38-.51l-.73-1.7H5.61l-.73 1.72c-.08.21-.2.38-.37.5s-.36.18-.56.18c-.31 0-.55-.09-.71-.27a.97.97 0 0 1-.23-.65c0-.1.02-.21.05-.32l3.7-8.89c.09-.22.23-.4.42-.53s.4-.18.63-.16a1.035 1.035 0 0 1 .96.69l3.65 8.7c.06.15.09.29.09.41 0 .31-.1.56-.31.75-.2.18-.43.28-.67.28zm-5.06-4.41h2.51L7.71 9.93zm10.28 4.49c-.71 0-1.36-.19-1.94-.55-.57-.36-1.03-.87-1.37-1.51-.33-.64-.5-1.38-.5-2.2s.17-1.58.5-2.21c.33-.64.79-1.15 1.35-1.51.57-.37 1.2-.55 1.89-.55.44 0 .85.07 1.22.2s.69.31.97.51c.03.02.06.04.08.07.04-.18.13-.34.26-.47q.3-.3.75-.3c.45 0 .55.1.74.3.2.2.3.45.3.76v6.28c0 .3-.1.55-.29.75-.2.2-.45.31-.75.31s-.55-.1-.75-.31c-.12-.12-.2-.26-.25-.42-.08.07-.16.14-.25.21-.25.19-.54.34-.88.47s-.71.2-1.1.2zm.23-6.61c-.39 0-.75.1-1.05.3s-.54.48-.71.83-.26.76-.26 1.21.09.84.26 1.2c.17.35.41.63.71.83q.45.3 1.05.3c.6 0 .76-.1 1.06-.3s.54-.48.71-.83.26-.76.26-1.2-.09-.86-.26-1.21-.41-.63-.71-.83-.66-.3-1.06-.3"
    />
  </svg>
);
export default SvgTextEditor;
